// src/modules/nav__module/nav__module.js
// ===============================
// NAV MODULE — Hamburguesa + Overlay (Transición Suave)
// ===============================

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('menuToggle'); // Botón hamburguesa
  const menu = document.getElementById('menu__Paginas'); // Menú móvil
  const overlay = document.getElementById('menuOverlay'); // Fondo oscuro

  // Seguridad: si falta algún elemento, no ejecuta nada
  if (!toggle || !menu || !overlay) return;

  // -------------------------------
  // ABRIR MENÚ
  // -------------------------------
  const openMenu = () => {
    // Limpia estados previos
    menu.classList.remove('closing');
    overlay.classList.remove('closing');

    // Activa estados de apertura
    menu.classList.add('open');
    overlay.classList.add('active');
    toggle.classList.add('open');

    // Accesibilidad
    toggle.setAttribute('aria-expanded', 'true');
  };

  // -------------------------------
  // CERRAR MENÚ (con transición suave)
  // -------------------------------
  const closeMenu = () => {
    // Activa animación de cierre
    menu.classList.add('closing');
    overlay.classList.add('closing');
    toggle.classList.remove('open');

    // Accesibilidad
    toggle.setAttribute('aria-expanded', 'false');

    // Espera la duración de la transición del SCSS (350ms)
    setTimeout(() => {
      menu.classList.remove('open', 'closing');
      overlay.classList.remove('active', 'closing');
    }, 350);
  };

  // -------------------------------
  // TOGGLE GENERAL
  // -------------------------------
  const toggleMenu = () => {
    const isOpen = menu.classList.contains('open');
    isOpen ? closeMenu() : openMenu();
  };

  // -------------------------------
  // Eventos
  // -------------------------------

  // Abrir/cerrar con el botón hamburguesa
  toggle.addEventListener('click', toggleMenu);

  // Cerrar al hacer clic en el overlay
  overlay.addEventListener('click', closeMenu);

  // Cerrar al hacer clic en un enlace del menú
  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  // Cerrar con tecla Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('open')) {
      closeMenu();
    }
  });
});
